export const adminSubRoute = {
  copyTemplate: "copy-template",
} as const;

export interface AdminRoutes {
  sub: typeof adminSubRoute.copyTemplate;
  method?: "Post";
}
